export enum FormulasOptions {
  OBJVAL = "OBJVAL",
  VELO = "VELO", //Bris et vol des vélos en tout lieu
  RCS = "RCS", //Assurance scolaire
  PJ = "PJ", //Protection juridique
  OPIS = "OPIS", //Piscine
  ANO = "ANO", //Assurance des objets nomades
  PJSOL = "PJSOL", //Protection juridique solidaire
  VAN = "VAN" //Valeur à neuf
}
